export default __webpack_public_path__ + "static/media/passwordicon.c34524b0.svg";